export enum  Product{

    PMG = 'PMG',

    MM = 'MM',

    PM = 'PM',

    MC = 'MC',

    MO = 'MO',

    MOI = 'MOI',

    MCF = 'MCF',

    MCI = 'MCI',

    MOG = 'MOG',

    MCM = 'MCM',

    MOF = 'MOF',

    MCG = 'MCG',

    MOFG = 'MOFG',

    CURRENT_ACCOUNT = 'CURRENT_ACCOUNT',

    DEBIT_CARD = 'DEBIT_CARD',

    SAVINGS_ACCOUNT = 'SAVINGS_ACCOUNT',

    DR = 'DR',

    MD = 'MD',

    DM = 'DM',

    DRABS = 'DRABS',

    DMABS = 'DMABS',

    MDABS = 'MDABS',

    DEPOSIT = 'DEPOSIT',

    F5 = 'F5',

    F10 = 'F10',

    F11 = 'F11',

    F12 = 'F12',

    F15 = 'F15',

    F20 = 'F20',

    RF3 = 'RF3',

    RF4 = 'RF4',

    RF5 = 'RF5',

    G05 = 'G05',

    G10 = 'G10',

    TPTI = 'TPTI',

    TPTG = 'TPTG'
}